export * from './event.component';
export * from './event-detail.component';
export * from './event-detail-no-auth.component';
export * from './event.route';
export * from './event-popup.service';
export * from './event-dialog.component';
export * from './event.model';
export * from './event.service';
export * from './event.util.service';
export * from './event-delete-dialog.component';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/index.ts